export enum ROUTE_NAMES {
  HOME = 'home',
  CEC = 'cec',
  FINMA_REGISTRATION = 'finma-registration',
  FINMA_COMMUNITIES = 'finma-communities',
  SEARCH = 'search',
  USERS = 'users',
  GROUPS = 'groups',
  LOGIN = 'login',
  REGISTRATION = 'registration',
  ACTIVATION = 'activation',
  SIGNING_ROOM = 'signing-room',
  ROOMS = 'rooms',
  BILLING = 'billing',
  CALENDAR = 'calendar',
  EVENTS = 'events',
  MESSAGES = 'messages',
  COMMUNITY = 'community',
  PRICE_CALCULATOR = 'price-calculator',
  RECENT = 'recent',
  REPORTING = 'reporting',
  FILE = 'file',
}
